import { SharedState } from './index';

const captchaSelector = (state: { common: { limiter: SharedState } }) => {
  const {
    common: { limiter },
  } = state;

  return limiter;
};

export default captchaSelector;
